export default function PageNotFound() {
    return (
      <div style={{textAlign: "center", padding: 150}}>
            <p>404 Page not found</p>
      </div>
    );
}